import React, { useEffect, useState } from 'react';
import Rating from "react-rating-stars-component";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popup from '../RegisterScreen/Popup';
import {
    faAngleLeft,
    faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { api } from "../../Constant";
import axios from 'axios';
import lovebg from "../../assets/images/love-bg.png";

function ProductSec({ onCartUpdate }) {
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [isWishlistActive, setIsWishlistActive] = useState({});
    const [username, setUsername] = useState("");
    const [userid, setUserid] = useState("")
    const [type, setType] = useState('')
    const [addsize, setAddsize] = useState('')
    const [activeButton, setActiveButton] = useState(null);
    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
        });
    }, []);

    const params = useParams();
    const productid = params.product_id;
    const [rating, setRating] = useState(3.5);
    const navigation = useNavigate('');
    const [productdetail, setProductdetail] = useState([]);

    useEffect(() => {
        // Assuming 'product_detail' is a variable holding the endpoint string
        const product_detail_endpoint = "product_detail"; // Example endpoint
        axios.post(api + product_detail_endpoint, { product_id: productid })
            .then((response) => {
                if (response.data.success === "true") {
                    setProductdetail(response.data.products);
                } else {
                    console.log('No products found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, [productid]);

    const ratingChanged = (newRating) => {
        setRating(newRating);
        console.log(`New rating: ${newRating}`);
    };

    const NextArrow = (props) => {
        const { className, onClick } = props;
        return (
            <div className={`${className} custom-arrow next-arrow`} onClick={onClick}>
                <FontAwesomeIcon icon={faAngleRight} className='icons-product' />
            </div>
        );
    };

    const PrevArrow = (props) => {
        const { className, onClick } = props;
        return (
            <div className={`${className} custom-arrow prev-arrow`} onClick={onClick}>
                <FontAwesomeIcon icon={faAngleLeft} className='icons-product' />
            </div>
        );
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        autoplay: true
    };

    const settingsr = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        if (productdetail.size && productdetail.size.length > 0) {
            const defaultSize = productdetail.size[0].size;
            const defaultid = productdetail.size[0].size_id
            setActiveButton(defaultSize);
            setAddsize(defaultid)
        }
    }, [productdetail.size]);

    const handleButtonClick = (sizeId) => {
        setActiveButton(sizeId);
        setAddsize(sizeId)
    };
    const handleclick = () => {
        navigation('/')
    };


    const handleIncrease = (max) => {
        setQuantity(prevQuantity => {
            if (prevQuantity < max) {
                return prevQuantity + 1;
            } else {
                return prevQuantity;
            }
        });
    };
    const handleDecrease = () => {
        if (quantity > 1) {
            setQuantity(prevQuantity => prevQuantity - 1);
        }
    };

    const whishlistClick = (productId) => {
        if (!username) {
            setPopupMessage("Please log in to use the wishlist feature.");
            setType("error");
            setPopupVisible(true);
            return;
        }
        const apiEndpoint = isWishlistActive[productId] ? "remove_wishlist" : "add_wishlist";
        const successMessage = isWishlistActive[productId]
            ? "Product removed successfully from Wishlist."
            : "Wishlist added successfully.";

        axios.post(api + apiEndpoint, {
            user_id: userid,
            product_id: productId,
        })
            .then((response) => {
                if (response.data.success === "true") {
                    setPopupMessage(successMessage);
                    setType("success");
                    setIsWishlistActive((prevState) => ({
                        ...prevState,
                        [productId]: !prevState[productId]
                    }));
                } else {
                    setPopupMessage("Failed to update wishlist.");
                    setType("error");
                }
                setPopupVisible(true);
            })
            .catch((error) => {
                setPopupMessage("An error occurred while updating the wishlist.");
                setType("error");
                setPopupVisible(true);
            });
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const addCartclick = (product_id, addsize, quantity) => {
        const guestId = localStorage.getItem('guest_id');
        const userId = localStorage.getItem('userId');

        if (!userId && !guestId) {
            setPopupMessage("Please log in or proceed as guest to add items to the cart.");
            setType("loginOrGuest");
            setPopupVisible(true);
            return;
        }

        const payload = {
            product_id,
            size: addsize,
            quantity,
        };

        if (userId && userId !== guestId) {
            payload.user_id = userId;
        } else {
            payload.guest_id = guestId;
        }

        axios.post(api + "add_cart", payload)
            .then((response) => {
                if (response.data.success === "true") {
                    setPopupMessage(response.data.message);
                    setType('success');
                    onCartUpdate();
                } else {
                    setPopupMessage("Failed to add to cart");
                    setType('error');
                }
                setPopupVisible(true);
            })
            .catch((error) => {
                console.log("Error:", error);
                setPopupMessage(error.response.data.message);
                setType("error");
                setPopupVisible(true);
            });
    };


    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        const storedUserid = localStorage.getItem('userId');
        setUsername(storedUsername || "");
        setUserid(storedUserid)
    }, []);

    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        const storeUserid = localStorage.getItem('userId');
        setUsername(storedUsername || "");
        setUserid(storeUserid || "");
        if (storeUserid) {
            axios.post(api + "wishlist", { user_id: storeUserid })
                .then((response) => {
                    if (response.data.success === "true") {
                        const wishlistProducts = response.data.product;
                        const wishlistState = wishlistProducts.reduce((acc, product) => {
                            acc[product.product_id] = true;
                            return acc;
                        }, {});
                        setIsWishlistActive(wishlistState);
                    } else {
                        console.log("No products found in wishlist");
                    }
                })
                .catch((error) => {
                    console.log("Error fetching wishlist:", error);
                });
        }
    }, []);

    const productdetailmove = (product_id) => {
        navigation(`/product-detail/${product_id}`)
    }
   const discount = Number(productdetail.discount_price);
const hasDiscount = discount > 0;
    return (
        <div className='productdetail-bg pt-80 pb-40'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-4 leftcontent-pro' >
                        <h6>{productdetail.category_name}</h6>
                        <h1>{productdetail.name}</h1>
                        <div className='rating-sec'>
                            {/* <Rating
                                count={5}
                                value={rating}
                                onChange={ratingChanged} isHalf={true}
                                size={20}
                                activeColor="#227070"
                                edit={false}
                            /> */}
                            {/* <p className='rating'>{rating}</p> */}
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: productdetail.description }}></p>
                 

<h2>
  ₹ {hasDiscount ? discount : productdetail.actual_price}

  {hasDiscount && (
    <span style={{
      textDecoration: "line-through",
      marginLeft: "10px",
      color: "gray",
      fontSize: "18px",
    }}>
      ₹ {productdetail.actual_price}
    </span>
  )}
</h2>

                    </div>
                    <div className='col-lg-4 product-bg' data-aos="zoom-in">
                        <Slider {...settings} >
                            {productdetail.productsub_images?.map((item, index) => (
                                <div key={index} className='product-imgproduct'>
                                    <img src={item.image} alt={`Product ${index + 1}`} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className='col-lg-4 rightcontent-product'>
                        <h6>SIZE</h6>
                        <div className="product-size">
                            {productdetail.size?.map((size) => (
                                <button
                                    key={size.size_id}
                                    onClick={() => handleButtonClick(size.size_id)}
                                    className={`size-button ${activeButton === size.size_id ? 'active' : ''}`}
                                >
                                    {size.size}
                                </button>
                            )) || <p>No sizes available</p>}
                        </div>
                        <h6>Quantity</h6>
                        <div className='heart-w-flex'>
                            <div className='product-qty-bg'>
                                <span className='minus' onClick={handleDecrease}> - </span>
                                <span className='quantity'> {quantity} </span>
                                <span className='plus' onClick={() => handleIncrease(productdetail.max_quantity)}> + </span>
                            </div>
                            <button onClick={() => whishlistClick(productdetail.product_id)}
                                style={{
                                    border: username && isWishlistActive[productdetail.product_id] ? '1px solid rgb(34, 112, 112)' : '1px solid #9f9c9c',
                                    color: username && isWishlistActive[productdetail.product_id] ? 'rgb(34, 112, 112)' : '#9f9c9c',
                                }}>Save to Wishlist <FontAwesomeIcon className='mx-2' icon={faHeart} /></button>

                        </div>
                        <button className='pro-buy-btn' onClick={handleclick}>Continue To Shopping</button>
                        <button onClick={() => addCartclick(productdetail.product_id, addsize, quantity)} className='pro-add-btn'>Add To Cart</button>
                    </div>
                </div>
                <div className='row pt-5' >
                    <div className='col-lg-12 product-description'>
                        <Tabs>
                            <TabList>
                                <Tab>Product Detail</Tab>
                                <Tab>Description</Tab>
                                <Tab>Wash Care</Tab>
                                {/* <Tab>Shipping/Returns</Tab> */}
                            </TabList>
                            <TabPanel>
                                <p className='product-dettab-phara' dangerouslySetInnerHTML={{ __html: productdetail.product_details }}></p>
                            </TabPanel>
                            <TabPanel>
                                <p className='product-dettab-phara' dangerouslySetInnerHTML={{ __html: productdetail.description }}></p>
                            </TabPanel>
                            <TabPanel>
                                <p className='product-dettab-phara' dangerouslySetInnerHTML={{ __html: productdetail.wash_care }}></p>
                            </TabPanel>
                            {/* <TabPanel>
                                <p className='product-dettab-phara' dangerouslySetInnerHTML={{ __html: productdetail.shipping_returns }}></p>
                            </TabPanel> */}
                        </Tabs>
                    </div>
                </div>
                <div className='row pt-5'>
                    <div className='col-lg-12 related-pro'>
                        <h1>You may also like</h1>
                    </div>
                    <Slider {...settingsr} className="related-pro-sec">
                        {Array.isArray(productdetail.relate_products) && productdetail.relate_products.length > 0 ? (
                           productdetail.relate_products.map((item) => (
    <div className='maincategory related-proscroll' key={item.product_id}>
        <div
            className='category-card'
            style={{
                backgroundImage: `url(${lovebg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '10px',
                padding: '15px',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <img
                src={item.product_image}
                alt='imge1'
                style={{
                    width: '100%',
                    borderRadius: '10px',
                    objectFit: 'cover',
                }}
            />

            <FontAwesomeIcon
                icon={faHeart}
                onClick={() => whishlistClick(item.product_id)}
                style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    color:
                        username && isWishlistActive[item.product_id]
                            ? "#92ad69"
                            : "rgb(191, 191, 191)",
                }}
            />
        </div>

 <div className='category-cardbottom'>
  <p>{item.name}</p>

  {Number(item.discount_price) > 0 ? (
    <h6>
      ₹ {item.discount_price}
      <span
        style={{
          textDecoration: 'line-through',
          marginLeft: '10px',
          color: 'gray',
          fontSize: '14px',
        }}
      >
        ₹ {item.price}
      </span>
    </h6>
  ) : (
    <h6>₹ {item.price}</h6>
  )}
</div>

        <div
            className='category-cardbottomone'
            onClick={() => productdetailmove(item.product_id)}
        >
            <a>Shop now</a>
        </div>
    </div>
))
                        ) : (
                            <p>No related products available.</p>
                        )}
                    </Slider>
                </div>
             {popupVisible && (
  <Popup
    message={popupMessage}
    title="Notice"
    type={type}
    onClose={handleClosePopup}
    product_id={productdetail.product_id}  // ✅ pass product_id
    addsize={addsize}                      // ✅ pass size
    quantity={quantity}                    // ✅ pass quantity
  />
)}

            </div>
        </div>
    );
}

export default ProductSec;